const Header = () => {
  return <h1 className="header">Random Users</h1>;
};

export default Header;